import React from 'react';
import { Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-slate-300 py-16" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-43">
          {/* Brand Column */}
          <div data-id="element-44">
            <div className="flex items-center gap-2 mb-4" data-id="element-45">
              <div className="w-8 h-8 rounded-lg bg-sky-500 flex items-center justify-center text-white font-bold" data-id="element-46">
                N
              </div>
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-47">
                Nimbusquest
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6" data-id="element-48">
              Cloud workflow automation for modern teams. Orchestrate your
              business logic without the headache.
            </p>
            <div className="flex gap-4" data-id="element-49">
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-50">
                <Twitter size={20} data-id="element-51" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-52">
                <Linkedin size={20} data-id="element-53" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-54">
                <Github size={20} data-id="element-55" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div data-id="element-56">
            <h4 className="text-white font-bold mb-4" data-id="element-57">Product</h4>
            <ul className="space-y-2 text-sm" data-id="element-58">
              <li data-id="element-59">
                <a href="#features" className="hover:text-sky-400 transition-colors" data-id="element-60">
                  Features
                </a>
              </li>
              <li data-id="element-61">
                <a href="#pricing" className="hover:text-sky-400 transition-colors" data-id="element-62">
                  Pricing
                </a>
              </li>
              <li data-id="element-63">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-64">
                  Integrations
                </a>
              </li>
              <li data-id="element-65">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-66">
                  Changelog
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-67">
            <h4 className="text-white font-bold mb-4" data-id="element-68">Company</h4>
            <ul className="space-y-2 text-sm" data-id="element-69">
              <li data-id="element-70">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-71">
                  About
                </a>
              </li>
              <li data-id="element-72">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-73">
                  Blog
                </a>
              </li>
              <li data-id="element-74">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-75">
                  Careers
                </a>
              </li>
              <li data-id="element-76">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-77">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-78">
            <h4 className="text-white font-bold mb-4" data-id="element-79">Legal</h4>
            <ul className="space-y-2 text-sm" data-id="element-80">
              <li data-id="element-81">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-82">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-84">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-sky-400 transition-colors" data-id="element-86">
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500" data-id="element-87">
          <div data-id="element-88">Limassol, Cyprus</div>
          <div data-id="element-89">&copy; 2026 Nimbusquest. All rights reserved.</div>
        </div>
      </div>
    </footer>;
}